module.exports = __webpack_public_path__ + "img/PW.c6f8e2a5.png";